import { render, staticRenderFns } from "./IColectivo.vue?vue&type=template&id=428e35be&scoped=true&"
import script from "./IColectivo.vue?vue&type=script&lang=js&"
export * from "./IColectivo.vue?vue&type=script&lang=js&"
import style0 from "./IColectivo.vue?vue&type=style&index=0&id=428e35be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e35be",
  null
  
)

export default component.exports